import { useEffect } from "react";
import { Container, CssBaseline, Grid } from "@mui/material";
import { Navigate, Outlet, useMatch } from "react-router-dom";
import { appPrefix, appDefaultRoute } from "pages/app-taxi-ranking";
import { Applications } from "configs";
import { useAppDispatch } from "store";
import { setRootPath } from "reducers/auth.reducer";
import { useShouldRenderPageGuard } from "hooks/useShouldRenderPageGuard";
import LoadingLayout from "layouts/common/loader/LoadingLayout.tsx";
import SidebarTaxiRank from "./drawer/SidebarTaxiRank";
import NavbarTaxiRank from "./header/NavbarTaxiRank";

const { AppIdTaxiRanking } = Applications;

export default function PlateSearchReportLayout() {
    const match = useMatch(appPrefix);
    const { shouldRender } = useShouldRenderPageGuard(AppIdTaxiRanking);
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(setRootPath("/taxi-ranking/home"));
    }, []);

    if (match) {
        return <Navigate to={appDefaultRoute} replace />;
    }

    return shouldRender ? (
        <Container maxWidth="xl" disableGutters>
            <CssBaseline />
            <NavbarTaxiRank />
            <Grid className="custom-container">
                <SidebarTaxiRank includeArchivedLocations />

                <div className="content">
                    <Outlet />
                </div>
            </Grid>
        </Container>
    ) : (
        <LoadingLayout />
    );
}
